import { AnalyticsState, AnalyticsUIState } from 'app/main/analytics/analytics.types';
import * as fromAnalytics from './analytics.reducer';
import * as fromAnalyticsUI from './analytics.ui.reducer';
import { Action, combineReducers } from '@ngrx/store';

export { fromAnalytics, fromAnalyticsUI };

export interface RouteState {
    api: AnalyticsState;
    ui: AnalyticsUIState;
}

export interface State {
    'analytics': RouteState;
}

export function reducers(state: RouteState | undefined, action: Action): RouteState {
    return combineReducers({
        api: fromAnalytics.reducer,
        ui: fromAnalyticsUI.reducer,
    })(state, action);
}
